export default "<p>show-user-location-dialog works!</p>\n"